import http from '@/http/index';

// 列表
export function meunList(params) {
    return http.get('/api/admin/menu/service/frame/menu-item/tree', params);
}

// 同步订单号
export function downloadByOrderIds(params) {
    return http.get('/api/basic/sync/order/downloadByOrderIds', params);
}

//获取店铺 
export function getShopsWithShopType(params) {
    return http.get('/api/basic/shop/getShopsWithShopType', params);
}

//任务列表
export function taskList(params) {
    return http.post('/api/admin/task-info/list', params);
}

//任务列表
export function download(params) {
    return http.get('/api/sys/long-task/download', params);
}
// 取消下载
export function cancelDownload(params) {
    return http.post('/api/sys/task/cancel',undefined, {params});
}

//获取下载成功失败接口
export function longPolling(params) {
    return http.get('/api/sys/message/long-polling', params);
}

// 用户信息
export function getUserByContext() {
    return http.get('/api/admin/user/getUserByContext');
}

// 新增
export function addUserAutoMenu(params) {
    return http.post('/api/admin/user/addUserAutoMenu', params);
}
// 查询
export function deleteUserAutoMenu(params) {
    return http.get('/api/admin/user/deleteUserAutoMenu',params);
}



